import utils from '@/helpers/utils'

export default {
  loadingProcesses (state) {
    if (!utils.count(state.processes)) return false
    let currentProcess = {}
    let key = Object.keys(state.processes)[0]
    currentProcess = state.processes[key]
    if (!currentProcess.message) currentProcess.message = 'Loading'
    return currentProcess
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js